module.exports = `${require.publicPath}下载_slices.65dfde92.zip`;